import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Paper,
  IconButton,
  Tooltip,
  Divider,
} from "@mui/material";
import {
  FaUpload,
  FaSearch,
  FaFilePdf,
  FaComments,
  FaBell,
  FaChartLine,
  FaCalendarAlt,
} from "react-icons/fa";
import { MdPayment } from "react-icons/md";
import moment from "moment";
import "./dashboard.css";
import axios from "axios";
import { API_URL } from "../../../config";
import { getCookie } from "../../../function";

const Dashboard = () => {
  const navigate = useNavigate();

  const [stats, setStats] = useState({
    totalArticles: 0,
    pendingArticles: 0,
    completedArticles: 0,
  });

  const handleNavigateSubmitArticle = () => {
    navigate("/client/submit-article");
  };

  const handleNavigateArticleList = () => {
    navigate("/client/Articles");
  };

  const handleNavigatePending = () => {
    navigate("/client/Articles?status=Pending");
  };

  const handleNavigateCompleted = () => {
    navigate("/client/Articles?status=Confirmed");
  };

  const StatCard = ({ title, value, icon, color, onClick, style }) => (
    <Card
      sx={{ height: "100%", backgroundColor: color, color: "white", ...style }}
      onClick={onClick}
    >
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box>
            <Typography variant="h6" gutterBottom>
              {title}
            </Typography>
            <Typography variant="h4">{value}</Typography>
          </Box>
          <Box>{icon}</Box>
        </Box>
      </CardContent>
    </Card>
  );

  const QuickActionCard = ({ title, description, icon, onClick, color }) => (
    <Card
      sx={{
        height: "100%",
        cursor: "pointer",
        transition: "transform 0.2s",
        "&:hover": {
          transform: "scale(1.02)",
          boxShadow: 3,
        },
      }}
      onClick={onClick}
    >
      <CardContent>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <Box sx={{ color: color, fontSize: "2.5rem" }}>{icon}</Box>
          <Typography variant="h6" align="center">
            {title}
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            {description}
          </Typography>
        </Box>
      </CardContent>
    </Card>
  );
  const getStats = async () => {
    const userid = getCookie("id");
    const res = await axios.get(`${API_URL}/getArticleStats?id=${userid}`, {
      headers: {
        Authorization: getCookie("token"),
        "x-api-key": "JjgeTensKk20J7GIxBfMSaA25Aricvmr1HYmjxpS",
      },
    });
    let parsedData = JSON.parse(res.data);
    let result = JSON.parse(parsedData.body);
    console.log(result.data);
    setStats(result.data);
  };
  useEffect(() => {
    getStats();
  }, []);

  return (
    <Box sx={{ p: 3 }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h4" component="h1">
          Dashboard
        </Typography>
        {/* <Box display="flex" gap={2}>
          <Tooltip title="Notifications">
            <IconButton>
              <FaBell />
            </IconButton>
          </Tooltip>
        </Box> */}
      </Box>

      <Grid container spacing={3}>
        {/* Stats Cards */}
        <Grid item xs={12} md={4}>
          <StatCard
            title="Total Invoices"
            value={stats.totalArticles}
            icon={<FaFilePdf size={40} />}
            color="#1976d2"
            onClick={handleNavigateArticleList}
            style={{ cursor: "pointer" }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <StatCard
            title="Pending Invoices"
            value={stats.pendingArticles}
            icon={<FaChartLine size={40} />}
            color="#f57c00"
            onClick={handleNavigatePending}
            style={{ cursor: "pointer" }}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <StatCard
            title="Confirmed Invoices"
            value={stats.completedArticles}
            icon={<FaCalendarAlt size={40} />}
            color="#388e3c"
            onClick={handleNavigateCompleted}
            style={{ cursor: "pointer" }}
          />
        </Grid>

        {/* Quick Actions */}
        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>
            Quick Actions
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <QuickActionCard
            title="Submit Invoice"
            description="Upload a new article for publication"
            icon={<FaUpload />}
            onClick={handleNavigateSubmitArticle}
            color="#1976d2"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <QuickActionCard
            title="Manage Invoices"
            description="View and manage your articles"
            icon={<FaSearch />}
            onClick={handleNavigateArticleList}
            color="#388e3c"
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
